/**
 * Shared React Query keys for the flows covered by INS-4022.
 *
 * Keys are structured arrays rather than interpolated strings so that partial-key
 * invalidation works (e.g. invalidateQueries(['courseAggregate']) drops every course).
 * React Query hashes keys structurally, so array contents are compared by value.
 *
 * The matching TTL lives with the cache policy in config/query-client.config.ts (CACHE_TTL).
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var queryKeys = {
    courseSectionInfo: function (courseId) { return ['courseSectionInfo', courseId]; },
    // ISBNs are sorted so the key is independent of the order they were derived in.
    eaqHesiCatalog: function (isbnList) { return ['eaqHesiCatalog', __spreadArray([], isbnList, true).sort()]; },
    eaqHesiCatalogByISBN: function (isbnList) { return ['eaqHesiCatalogByISBN', __spreadArray([], isbnList, true).sort()]; },
    courseAggregate: function (courseSectionId, instructorId) { return ['courseAggregate', courseSectionId, instructorId]; },
    // Keyed on the whole ISBN list rather than per ISBN: fetchMasteryAssessment aggregates across
    // ISBNs, and its URL already includes the courseId, so per-ISBN entries could never be reused
    // by another course anyway.
    masteryAssessment: function (isbnList, courseId) { return ['masteryAssessment', __spreadArray([], isbnList, true).sort(), courseId]; },
    // Shared by useAssignmentSummaryHook and useInstructorHomeProgressing, which previously used
    // two different keys for the identical request and so fetched it twice on one page.
    assignmentSummary: function (courseSectionId) { return ['assignmentSummary', courseSectionId]; },
    // The rest of the setCourseSectionInfo cascade in App.tsx. Without these, remounting a page that
    // calls setCourseSectionInfo refetches them even though the course section itself is cached.
    allEolsUsers: function (eolsUserId, systemType) { return ['allEolsUsers', eolsUserId, systemType]; },
    relatedUserInfo: function (eolsUserId) { return ['relatedUserInfo', eolsUserId]; },
    catalog: function (eolsUserId, courseSectionId, resourceType) { return ['catalog', eolsUserId, courseSectionId, resourceType]; },
    cwAssignments: function (courseSectionId) { return ['cwAssignments', courseSectionId]; },
    // Shared by the WGU instructor home student search and the WGU student detail switcher.
    courseStudents: function (courseId) { return ['courseStudents', courseId]; },
    crosswalkUser: function (eolsUserId) { return ['crosswalkUser', eolsUserId]; },
    instructorCourses: function (instructorIds) { return ['instructorCourses', __spreadArray([], (instructorIds || []), true).sort()]; }
};
